import classnames from 'classnames';
import {
  getMatchStatus,
  MATCH_STATUS,
  OPTA_STATUSES,
  OptaMatchStatus,
} from '@stadionhq-v3/core';
import styles from './fixtureAlertHeader.module.scss';
import { FixtureAlertHeaderProps } from './fixtureAlertHeader.types';

const FixtureAlertHeader = ({
  nativeProps,
  classNames,
  labels,
  matchStatus,
}: FixtureAlertHeaderProps) => {
  const mapStatusToCopyConfig: {
    [K in OptaMatchStatus]?: {
      backgroundColor: string;
      copy?: string;
      textColor?: string;
    };
  } = {
    [OPTA_STATUSES.CANCELLED]: {
      backgroundColor: 'cancelledBackground',
      copy: labels?.cancelled,
      textColor: 'white',
    },
    [OPTA_STATUSES.POSTPONED]: {
      backgroundColor: 'postponedBackground',
      copy: labels?.postponed,
      textColor: 'black',
    },
    [OPTA_STATUSES.ABANDONED]: {
      backgroundColor: 'abandonedBackground',
      copy: labels?.abandoned,
      textColor: 'white',
    },
  };

  const classes = classnames(
    [
      styles.tokens,
      styles.fixtureAlertHeader,
      ...(mapStatusToCopyConfig[matchStatus]?.backgroundColor
        ? [
            styles[
              mapStatusToCopyConfig[matchStatus]?.backgroundColor as string
            ],
          ]
        : []),
      ...(mapStatusToCopyConfig[matchStatus]?.textColor
        ? [styles[mapStatusToCopyConfig[matchStatus]?.textColor as string]]
        : []),
      ...(getMatchStatus(matchStatus) === MATCH_STATUS.LIVE
        ? [styles.liveBackground, styles.white]
        : []),
    ],
    classNames
  );

  return (
    <div
      {...nativeProps}
      className={classes}
      data-component="FixtureAlertHeader"
    >
      {mapStatusToCopyConfig[matchStatus]?.copy}
      {getMatchStatus(matchStatus) === MATCH_STATUS.LIVE ? labels?.live : null}
    </div>
  );
};

export default FixtureAlertHeader;
